<app-report-list *ngIf="user != null && reports != null"
                 [reports]="reports"
                 [clientId]="user.clientId"
                 [immutable]="true">
</app-report-list>
